// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KRPT","icon":"styles_icon__QWY1T"};